import {NEW_VEHICLE_MAX_DAYS_ON_STOCK} from '../consts/newVehicleMaxDaysOnStock';
import {ExtendedStatisticsCar} from '../types/ExtendedStatisticsCar';

export function isNewVehicleInAdvertisement(car: ExtendedStatisticsCar) {
  return car.days_on_stock <= NEW_VEHICLE_MAX_DAYS_ON_STOCK;
}
